// 中文
const zh = {
  描述:"描述",
  图片: '图片',
  名称: '名称',
  产品编码: '产品编码',
  总数: '总数',
  件数: '件数',
  home: '首页',
  用户账号: '用户账号',
  昵称: '昵称',
  product: '产品中心',
  产品分类: '产品分类',
  新商品: '新商品',
  降价产品: '降价商品',
  全部分类: '全部分类',
  返回首页: '返回首页',
  注册: '注册',
  我的账户: '我的账户',
  我的采购单: '我的采购单',
  欢迎光临舱多保产品库: '欢迎光临舱多保产品库',
  你好请登录: '你好。请登录',
  请输入您想要搜索的内容: '请输入您想要搜索的内容',
  login: '你好，请登录',
  search: '搜索',
  exit: '退出',
  爆款推荐: '爆款推荐',
  新产品: '新商品',
  降价产品: '降价商品',
  人付款: '人付款',
  加入购物车: '加入购物车',
  登录: '登录',
  收藏夹: '收藏夹',
  个人中心: '个人中心',
  首页: '首页',
  价格筛选: '价格筛选',
  更多: '更多',
  由高到低: '由高到低',
  由低到高: '由低到高',
  上一页: '<  上一页',
  下一页: '下一页  >',
  爆款: '爆款',
  产品编码: '产品编码',
  装箱数: '装箱数',
  每箱体积: '每箱体积',
  每箱重量: '每箱重量',
  分类: '分类',
  最小起订箱: '最小起订箱',
  数量: '数量',
  箱: '箱',
  加入常购清单: '加入常购清单',
  加入购物车: '加入购物车',
  收藏: '收藏',
  订单中心: '订单中心',
  常购清单: '常购清单',
  账户管理: '账户管理',
  个人信息: '个人中心',
  收货地址: '收货地址',
  修改密码: '修改密码',
  我的留言: '我的留言',
  申请开店: '申请开店',
  全部: '全部',
  修改个人信息: '修改个人信息 >',
  请输入订单编号: '请输入订单编号',
  商品: '商品',
  单价: '单价',
  数量: '数量',
  操作: '操作',
  订单号: '订单号',
  订单状态: '订单状态',
  已下单: '已下单',
  处理中: '处理中',
  已发货: '已发货',
  已完成: '已完成',
  已取消: '已取消',
  订单取消: '订单取消',
  已提交: '已提交',
  下单时间: '下单时间',
  支付状态: '支付状态',
  待支付: '待支付',
  已支付: '已支付',
  交易成功: '交易成功',
  物流运输中: '物流运输中',
  订单详情: '订单详情',
  取消: '取消',
  确认收货: '确认收货',
  订单完成: '订单完成',
  订单总额: '订单总额',
  打印: '打印',
  导出: '导出',
  下载: '下载',
  配送地址: '配送地址',
  收货地址: '收货地址',
  姓名: '姓名',
  电话号码: '电话号码',
  公司名称: '公司名称',
  邮政编码: '邮政编码',
  详细地址: '详细地址',
  配送: '配送',
  配送方式: '配送方式',
  货运信息: '货运信息',
  船运: '船运',
  空运: '空运',
  付款方式: '付款方式',
  支付信息: '支付信息',
  收款公司: '收款公司',
  收款账号: '收款账号',
  收款银行: '收款银行',
  公司地址: '公司地址',
  银行地址: '银行地址',
  付款凭证: '付款凭证',
  商品清单: '商品清单',
  商品图片: '商品图片',
  商品编码: '商品编码',
  商品名称: '商品名称',
  箱数: '箱数',
  体积: '体积',
  重量: '重量',
  金额: '金额(箱)',
  总重量: '总重量',
  总体积: '总体积',
  总金额: '总金额',
  全选: '全选',
  删除: '删除',
  批量管理: '批量管理',
  导入常购清单: '导入常购清单',
  性别: '性别',
  男: '男',
  女: '女',
  保密: '保密',
  出生日期: '出生日期',
  选择日期: '选择日期',
  头像: '头像',
  邮箱: '邮箱',
  个性签名: '个性签名',
  保存: '保存',
  您已创建: '您已创建',
  个收货地址: '个收货地址',
  最多可创建: '最多可创建',
  个: '个',
  新增收货地址: '新增收货地址',
  手机号码: '手机号码',
  地址: '地址',
  编辑: '编辑',
  所在地区: '所在地区',
  请选择: '请选择',
  修改密码: '修改密码',
  当前密码: '当前密码',
  新密码: '新密码',
  确认密码: '确认密码',
  日期: '日期',
  回复: '回复',
  留言: '留言',
  请输入内容: '请输入内容',
  提交: '提交',
  联系人: '联系人',
  联系电话: '联系电话',
  手机号码: '手机号码',
  申请入驻: '申请入驻',
  购物车: '购物车',
  全部: '全部',
  件: '件',
  已选择: '已选择',
  移入收藏夹: '移入收藏夹',
  去付款: '去付款',
  结账: '结账',
  选择收货地址: '选择收货地址',
  管理收货地址: '管理收货地址',
  选择配送方式: '选择配送方式',
  支付信息: '支付信息',
  确认: '确认',
  留言管理: '留言管理',
  标题: '标题',
  留言内容: '留言内容',
  请输入用户名: '请输入用户名',
  请输入密码: '请输入密码',
  忘记密码: '忘记密码',
  记住我: '记住我',
  进入官网: '进入官网',
  请正确输入邮箱: '请正确输入邮箱',
  密码必须是的非空字符: '密码必须是6-18的非空字符',
  找回密码: '找回密码',
  输入请您的邮箱: '输入您的邮箱',
  请输入注册邮箱: '请输入注册的邮箱',
  下一步: '下一步',
  请正确输入邮箱: '请正确输入邮箱',
  验证信息: '验证信息',
  设置新密码: '设置新密码',
  重置成功: '重置成功',
  验证码已发送至: '验证码已发送至',
  请输入邮箱内验证码进行重置密码: '请输入邮箱内验证码进行重置密码',
  请输入验证码: '请输入验证码',
  发送验证码: '发送验证码',
  重新发送: '重新发送',
  验证码不能为空: '验证码不能为空',
  两次输入的密码不一致: '两次输入的密码不一致',
  请再次输入密码: '请再次输入密码',
  恭喜您密码重置成功快去登录吧: '恭喜您密码重置成功,快去登录吧',
  登陆: '登录',
  商品详情: '商品详情',
  推荐商品: '推荐商品',
  成功加入收藏夹: '成功加入收藏夹',
  成功加入常购清单: '成功加入常购清单',
  添加成功: '添加成功',
  您还未登录即将跳转登录页面: '您还未登录即将跳转登录页面',
  请选择商品再结算: '请选择商品再结算',
  下单成功: '下单成功',
  请输入留言标题: '请输入留言标题',
  请输入留言内容: '请输入留言内容',
  提交成功: '提交成功',
  修改成功: '修改成功',
  密码修改成功即将重新登录: '密码修改成功即将重新登录',
  请检查当前密码输入是否正确: '请检查当前密码输入是否正确',
  回复成功: '回复成功',
  请输入回复内容: '请输入回复内容',
  上传头像图片只能是JPGJPEGPNG格式: '上传头像图片只能是JPG、JPEG、PNG格式!',
  上传头像图片大小不能超过2MB: '上传头像图片大小不能超过2MB',
  请输入姓名: '请输入姓名',
  请输入出生年月日: '请输入出生年月日',
  请上传头像: '请上传头像',
  请输入公司名称: '请输入公司名称',
  请输入电话号码: '请输入电话号码',
  请输入个性签名: '请输入个性签名',
  请选择性别: '请选择性别',
  请输入邮箱: '请输入邮箱',
  个人信息保存成功: '个人信息保存成功',
  您的入驻申请通过: '您的入驻申请通过',
  您的入驻申请正在审核中: '您的入驻申请正在审核中',
  您的入驻申请未通过未通过的原因为: '您的入驻申请未通过未通过的原因为',
  请输入手机号码: '请输入手机号码',
  请输入联系电话: '请输入联系电话',
  请输入联系人: '请输入联系人',
  您的开店申请以提交请等待审核: '您的开店申请以提交请等待审核',
  邮箱注册: '邮箱注册',
  微信: '微信',
  电话: '联系电话',
  回顶部: '回顶部',
  打开微信: '打开微信',
  扫码添加客服: '扫码添加客服',
  综合: '综合',
  销量: '销量',
  新品: '新品',
  价格: '价格',
  更多: '更多',
  请上传文件材料: '请上传文件材料',
  舱多保供应链版权所有: '舱多保供应链版权所有',
  您的订单已经处理成功订单号: '您的订单已经处理成功! 订单号:',
  查看订单: '查看订单',
  导入购物车: '导入购物车',
  销量筛选: '销量筛选',
  MOQ: '',
  SetS: '',
  共有: '共有',
  转到购物车: '转到购物车',
  生成采购单: '生成采购单',
  暂无发货清单: '暂无发货清单',
  发货清单:'发货清单',
  导出Excel: '导出Excel',
  符号:'￥',
  language: {
    zh: '中文',
    en: 'English',
    es: 'Español',
    por: 'Português'
  }
}

export default zh
